const isOneOf = (literals) => (value) => literals.includes(value);

export { isOneOf };
